import React from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '400px',
    margin: theme.spacing.unit,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  chart: {
    width: '100px',
    height: '100px',
    backgroundColor: 'grey',
    margin: theme.spacing.unit,
  }
});

const JobMetrics = ({ classes }) => {
  return (
    <Card className={classes.root}>
      <CardHeader
        subheader="Charts"
      />
    <div className={classes.row}>
        <div className={classes.chart}>
        </div>
        <div className={classes.chart}>
        </div>
        <div className={classes.chart}>
        </div>
      </div>
    </Card>
  );
};

export default withStyles(styles)(JobMetrics);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobMetrics.jsx